/* global localStorage */
export function length () {
  return localStorage.length
}

export function key (i) {
  return localStorage.key(i)
}

export function getItem (keyName) {
  const hasExpired = itemHasExpired(keyName)

  if (hasExpired) {
    removeItem(keyName)
  }

  return getValue(keyName)
}

export function setItem (keyName, keyValue, options = {}) {
  const expiresAt = typeof options.expiresAt === 'number' ? options.expiresAt : getExpiresAt(keyName)

  const value = JSON.stringify({
    value: keyValue,
    expiresAt
  })

  localStorage.setItem(keyName, value)
}

export function removeItem (keyName) {
  localStorage.removeItem(keyName)
}

export function clear () {
  localStorage.clear()
}

function getValue (keyName) {
  const item = localStorage.getItem(keyName)
  try {
    return JSON.parse(item).value
  } catch (e) {
    return item
  }
}

function itemHasExpired (keyName) {
  const now = Date.now()
  const expiresAt = getExpiresAt(keyName)

  const expirable = typeof expiresAt === 'number'
  if (!expirable) {
    return false
  }

  return now >= expiresAt
}

function getExpiresAt (keyName) {
  const item = localStorage.getItem(keyName)
  try {
    return JSON.parse(item).expiresAt
  } catch (e) {
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/localStorage.js